import { FormGroup, FormControl } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ApiParameterService } from './../../../../services/api/api-parameter.service';
import { SnackbarService } from './../../../../services/snackbar.service';
import { IParameter, IParameterForm } from './../../../../models/parameter';

@Component({
  selector: 'app-modal-parametros',
  templateUrl: './modal-parametros.component.html',
  styleUrls: ['./modal-parametros.component.scss']
})
export class ModalParametrosComponent implements OnInit {
  form!: FormGroup<IParameterForm>;
  parameter!: IParameter;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalParametrosComponent>,
    private _snackbarService: SnackbarService,
    private _parameterService: ApiParameterService
  ) {
    this.parameter = data as IParameter;
  }

  ngOnInit(): void {
    this.builderParameterForm();
  }

  builderParameterForm(): void {
    this.form = new FormGroup<IParameterForm>({
      ParameterId: new FormControl<string>('', { nonNullable: true }),
      Name: new FormControl<string>({value: '', disabled: true}, { nonNullable: true }),
      Value: new FormControl<string>('', { nonNullable: true })
    });

    this.form.patchValue(this.parameter);
  }

  handlerParameter(): void {
    const parameter = this.form.getRawValue() as IParameter;

    this._parameterService.updateParameter(parameter).subscribe({
      next: (response) => {
        this._snackbarService.openSnackBar('Parâmetro atualizado com sucesso!', 'success', 3500);
        this.dialogRef.close(parameter);
      }
    })
  }
}
